import React, { useState, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { object, string, bool } from 'prop-types';
import Cookies from 'js-cookie';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '../../../../Typography';
import ROUTES, { getPath } from '../../../../../routes';
import { makeURLWithParams } from '../../../../../utils/globals';
import { COOKIE_NAME, COOKIE_VALUE } from './constants';
import messages from './messages';
import useStyles from './styles';

const getCookie = name => Boolean(Cookies.get(name));

const CookieBanner = ({ settings: { COOKIE_DURATION, COOKIES_PDF }, token, isEmbedded }) => {
  const classes = useStyles();
  const [cookie, setCookie] = useState(getCookie(`${token}_${COOKIE_NAME}`));

  const crossSiteCookie = isEmbedded && { SameSite: 'None', Secure: true };

  const updateCookie = () => {
    Cookies.set(`${token}_${COOKIE_NAME}`, COOKIE_VALUE, { expires: COOKIE_DURATION, ...crossSiteCookie });
    const cookieValue = getCookie(`${token}_${COOKIE_NAME}`);
    setCookie(cookieValue);
  };

  if (!cookie) {
    return (
      <Grid container name="cookieBanner" alignItems="center" justify="space-between" style={classes.container}>
        <Grid item>
          <Typography content={messages.cookieMessage} variant="subtitle2" style={{ color: 'white' }} />
        </Grid>
        <Grid item>
          <Button
            target="_blank"
            href={makeURLWithParams(getPath(ROUTES.LEGISLATION), {
              pdf: COOKIES_PDF ? 'cookies_legacy' : 'term_condition',
            })}
            style={classes.button}
            variant="outlined"
          >
            <FormattedMessage {...messages.moreInfosButton} />
          </Button>
          <Button onClick={updateCookie} style={classes.button} variant="outlined">
            <FormattedMessage {...messages.okButton} />
          </Button>
        </Grid>
      </Grid>
    );
  }

  return <Fragment />;
};

CookieBanner.propTypes = {
  settings: object,
  token: string,
  isEmbedded: bool,
};

export default CookieBanner;
